export const TextWithSubTitle = ({titles, titleStyles = {}, subTitleStyles = {}}) => {
  if (Array.isArray(titles) && titles.length > 1) {
    const title = titles[0];
    const subTitle = titles.slice(1);
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <div>
          <div
            style={{
              fontFamily: "Inter",
              fontSize: "12px",
              lineHeight: "17px",
              fontWeight: 600,
              color: "#666666",
              ...titleStyles,
            }}
          >
            {title}
          </div>
          <div
            style={{
              marginTop: "2px",
              fontFamily: "Inter",
              fontSize: "12px",
              color: "#A5A5A5",
              ...subTitleStyles,
            }}
          >
            {subTitle}
          </div>
        </div>
        <div className={"highlight"}/>
      </div>
    );
  }
  return <>{titles}</>;
};
